{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Overfør til en operatør",
    "MESSAGE": "Stil mig om til en operatør"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Download",
      "UPLOADING": "Uploader..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Send"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Send besked igen",
      "ERROR_MESSAGE": "Kunne ikke sende, prøv igen"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Bedøm kvaliteten af dette svar"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Vent venligst på, at en agent deltager"
  },
  "ROBOT_CHECK": {
    "TITLE": "Hurtig sikkerhedskontrol",
    "DESCRIPTION": "Udfør venligst kontrollen nedenfor.",
    "VERIFYING": "Bekræfter…",
    "ERROR": "Det virkede ikke. Prøv venligst igen.",
    "RETRY": "Prøv igen"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Vi er online",
    "OFFLINE": "Vi er ikke tilgængelige i øjeblikket",
    "ONLINE_WITH_BOT": "Holdet og vores AI-assistent er online",
    "OFFLINE_WITH_BOT": "Vores AI-assistent er her for at hjælpe",
    "BOT_ONLY_REPLY": "Svarer øjeblikkeligt"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Svarer typisk på et par minutter",
    "IN_A_FEW_HOURS": "Svarer typisk på et par timer",
    "IN_A_DAY": "Svarer typisk på en dag",
    "BACK_IN": "Vi er tilbage online"
  },
  "DAY_NAMES": {
    "SUNDAY": "søndag",
    "MONDAY": "mandag",
    "TUESDAY": "tirsdag",
    "WEDNESDAY": "onsdag",
    "THURSDAY": "torsdag",
    "FRIDAY": "fredag",
    "SATURDAY": "lørdag"
  },
  "START_CONVERSATION": "Start Samtale",
  "END_CONVERSATION": "Afslut Samtale",
  "CONTINUE_CONVERSATION": "Fortsæt samtale",
  "YOU": "Dig",
  "START_NEW_CONVERSATION": "Start en ny samtale",
  "RESOLVE_LATER": "Vi løser dette emne via e-mail/telefon. Jeg vil gerne spørge om noget andet nu.",
  "VIEW_UNREAD_MESSAGES": "Du har ulæste beskeder",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Se nye beskeder",
    "CLOSE_MESSAGES_BUTTON": "Luk",
    "COMPANY_FROM": "fra",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Chat med os"
  },
  "POWERED_BY": "Drevet af {brandName}",
  "EMAIL_PLACEHOLDER": "Indtast venligst din e-mail",
  "CHAT_PLACEHOLDER": "Skriv din besked",
  "TODAY": "I dag",
  "YESTERDAY": "I går",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Fulde Navn",
        "PLACEHOLDER": "Indtast venligst dit fulde navn",
        "REQUIRED_ERROR": "Det fulde navn er påkrævet"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "E-Mail Adresse",
        "PLACEHOLDER": "Indtast venligst din e-mail adresse",
        "REQUIRED_ERROR": "E-mail adresse er påkrævet",
        "VALID_ERROR": "Angiv venligst en gyldig e-mailadresse"
      },
      "PHONE_NUMBER": {
        "LABEL": "Telefonnummer",
        "PLACEHOLDER": "Indtast venligst dit telefonnummer",
        "REQUIRED_ERROR": "Telefonnummer er påkrævet",
        "DIAL_CODE_VALID_ERROR": "Vælg venligst en landekode",
        "VALID_ERROR": "Indtast et gyldigt telefonnummer",
        "DROPDOWN_EMPTY": "Ingen resultater fundet",
        "DROPDOWN_SEARCH": "Søg land"
      },
      "MESSAGE": {
        "LABEL": "Besked",
        "PLACEHOLDER": "Indtast venligst din besked",
        "ERROR": "Beskeden er for kort"
      }
    },
    "CAMPAIGN_HEADER": "Angiv venligst dit navn og e-mail, før du starter samtalen",
    "IS_REQUIRED": "er påkrævet",
    "REQUIRED": "Påkrævet",
    "REGEX_ERROR": "Angiv venligst et gyldigt input"
  },
  "FILE_SIZE_LIMIT": "Filen overskrider grænsen på {MAXIMUM_FILE_UPLOAD_SIZE} for vedhæftede filer",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Ugyldigt felt"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Søg efter emojis",
    "NOT_FOUND": "Ingen emoji matcher din søgning",
    "ARIA_LABEL": "Emoji vælger"
  },
  "CSAT": {
    "TITLE": "Bedøm din samtale",
    "SUBMITTED_TITLE": "Tak for din bedømmelse",
    "PLACEHOLDER": "Fortæl os mere..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Anmod om en samtaleudskrift",
    "SEND_EMAIL_SUCCESS": "Chatudskriften blev sendt med succes",
    "SEND_EMAIL_ERROR": "Der opstod en fejl. Prøv venligst igen"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Populære Artikler",
    "VIEW_ALL_ARTICLES": "Se alle artikler",
    "IFRAME_LOAD_ERROR": "Der opstod en fejl under indlæsning af artiklen. Genindlæs venligst siden og prøv igen."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Åbn",
      "BUY": "Køb"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Billedbesked"
    },
    "audio": {
      "CONTENT": "Lydbesked"
    },
    "video": {
      "CONTENT": "Video besked"
    },
    "file": {
      "CONTENT": "Fil Vedhæftning"
    },
    "location": {
      "CONTENT": "Lokation"
    },
    "fallback": {
      "CONTENT": "har delt en URL"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Besvarer til:"
  }
}
